if (!document.head) {
  document.addEventListener('DOMContentLoaded', function () {});
}

// find elem in focus --DEBUGGER       
(function () {
  document.addEventListener(
    'focusin',
    function (e) {
      var el = e.target;
      var name =
        el.getAttribute('aria-label') ||
        el.textContent?.trim()?.slice(0, 80) ||
        '';
      console.log('focusin:', el.tagName.toLowerCase(), el.className || '', name);
    },
    true
  );
  console.log('focusin logger installed');
})();

// SKIP LINK, FOCUS H1 
(function initSkipToContentFocus() {
  const skipLink = document.querySelector('a.skip-link-v2[href="#MainContent"]');
  if (!skipLink) return;

  skipLink.addEventListener('click', (e) => {
    e.preventDefault();

    const main = document.getElementById('MainContent');
    if (!main) return;

    const h1 = main.querySelector('h1');

    const focusTarget = h1 || main;

    if (!focusTarget.hasAttribute('tabindex')) {
      focusTarget.setAttribute('tabindex', '-1');
    }

    focusTarget.focus({ preventScroll: true });
    focusTarget.scrollIntoView({ block: 'start' });

    if (focusTarget !== main) {
      setTimeout(() => {
        focusTarget.removeAttribute('tabindex');
      }, 0);
    }
  });
})();

// a11y: lock focus-enabled once keyboard navigation begins
(function () {
  let keyboardUsed = false;

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') {
      keyboardUsed = true;
      document.body.classList.add('focus-enabled');
    }
  }, true);

  document.addEventListener('mousedown', function () {
    if (keyboardUsed) {
      document.body.classList.add('focus-enabled');
    }
  }, true);
})();

// newsletter injecting bad ARIAs --
(function () {
  function removeBadFocusAttrs() {
    document
      .querySelectorAll(
        '.standard__newsletter[role="button"], ' +
        '.float__wrapper[role="button"], ' +
        'span.input-group-button[role="button"]'
      )
      .forEach((el) => {
        el.removeAttribute('role');
        el.removeAttribute('tabindex');
      });

    document
      .querySelectorAll('.header__mobile__left[aria-label]')
      .forEach((el) => {
        el.removeAttribute('aria-label');
      });

    document
      .querySelectorAll('button.header__mobile__button[aria-controls="header-menu"]')
      .forEach((el) => {
        el.removeAttribute("aria-controls");
      });
  }

  document.addEventListener("DOMContentLoaded", removeBadFocusAttrs);
  document.addEventListener("shopify:section:load", removeBadFocusAttrs);
  document.addEventListener("shopify:section:select", removeBadFocusAttrs);
})();


/**** FOOTER ACCORDION (mobile) ****/
(function() {

  // Cleanup: remove incorrect aria-haspopup + ensure tabindex on mobile
  function cleanupFooterAccordions() {
    document.querySelectorAll('[data-section-type="footer"] [data-accordion-trigger]').forEach(btn => {
      btn.removeAttribute('aria-haspopup');

      if (window.innerWidth < 768) {
        btn.setAttribute('tabindex', '0');
      }
    });
  }

  // Sync aria-expanded with actual open state
  function syncFooterAriaExpanded() {
    const triggers = document.querySelectorAll('[data-section-type="footer"] [data-accordion-trigger]');

    triggers.forEach((btn) => {
      if (window.innerWidth >= 768) return;

      const isOpen = btn.classList.contains('accordion-is-open');
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  // Keyboard support (Enter / Space)
  function handleAccordionKeyboard(e) {
    const trigger = e.target.closest('[data-accordion-trigger]');
    if (!trigger) return;

    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      trigger.click();
    }
  }

  // Initialize everything
  document.addEventListener('DOMContentLoaded', () => {
    cleanupFooterAccordions();
    syncFooterAriaExpanded();
  });

  window.addEventListener('resize', () => {
    cleanupFooterAccordions();
    syncFooterAriaExpanded();
  });

  document.addEventListener('shopify:section:load', () => {
    cleanupFooterAccordions();
    syncFooterAriaExpanded();
  });

  // Immediate sync after click
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-accordion-trigger]')) {
      setTimeout(syncFooterAriaExpanded, 100);
    }
  });

  // Keyboard support
  document.addEventListener('keydown', handleAccordionKeyboard);

})();


// Sync tabpanel visibility with focusability:
// When a tab panel is inactive (aria-hidden="true"), remove all descendants from the tab order.
// When a tab panel becomes active, restore its original focus behavior.
(function () {
  var FOCUSABLE = 'a[href],area[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex],[contenteditable="true"]';

  function setHidden(panel, hidden) {
    if (!panel) return;

    if (hidden) {
      panel.setAttribute('inert', '');
      if (panel.getAttribute('tabindex') !== null && !panel.hasAttribute('data-orig-tabindex')) {
        panel.setAttribute('data-orig-tabindex', panel.getAttribute('tabindex'));
      }
      panel.setAttribute('tabindex', '-1');

      panel.querySelectorAll(FOCUSABLE).forEach(function (el) {
        if (!el.hasAttribute('data-orig-tabindex')) {
          el.setAttribute('data-orig-tabindex', el.getAttribute('tabindex') === null ? '' : el.getAttribute('tabindex'));
        }
        el.setAttribute('tabindex', '-1');
      });
    } else {
      panel.removeAttribute('inert');

      if (panel.hasAttribute('data-orig-tabindex')) {
        var t = panel.getAttribute('data-orig-tabindex');
        panel.removeAttribute('data-orig-tabindex');
        if (t === '') panel.removeAttribute('tabindex');
        else panel.setAttribute('tabindex', t);
      } else {
        panel.removeAttribute('tabindex');
      }

      panel.querySelectorAll('[data-orig-tabindex]').forEach(function (el) {
        var ot = el.getAttribute('data-orig-tabindex');
        el.removeAttribute('data-orig-tabindex');
        if (ot === '') el.removeAttribute('tabindex');
        else el.setAttribute('tabindex', ot);
      });
    }
  }

  function syncAll() {
    document.querySelectorAll('[role="tabpanel"]').forEach(function (panel) {
      var hidden = panel.getAttribute('aria-hidden') === 'true';
      setHidden(panel, hidden);
    });
  }

  function observe() {
    var panels = document.querySelectorAll('[role="tabpanel"]');
    if (!panels.length) return;

    var obs = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'attributes' && m.attributeName === 'aria-hidden') {
          var panel = m.target;
          setHidden(panel, panel.getAttribute('aria-hidden') === 'true');
        }
      });
    });

    panels.forEach(function (panel) {
      obs.observe(panel, { attributes: true });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncAll();
    observe();
  });

  document.addEventListener('shopify:section:load', syncAll);
  document.addEventListener('shopify:section:select', syncAll);
})();

// ISSUU Flipbook title override
(function () {
  function updateIssuuIframeTitles() {
    document.querySelectorAll('iframe[src*="e.issuu.com/embed"]').forEach(function (iframe) {
      if (!iframe.dataset.a11yTitleSet) {
        var productTitleEl = document.querySelector('.product__title');
        if (!productTitleEl) return;

        iframe.setAttribute(
          'title',
          'Issuu flipbook preview for ' + productTitleEl.textContent.trim()
        );

        iframe.dataset.a11yTitleSet = 'true';
      }
    });
  }

  window.addEventListener('load', updateIssuuIframeTitles);
})();


// theme adds aria-haspopup to sidebar accordion buttons
// these buttons do not open popups, so we remove it
// retry handles late accordion initialization
(function () {
  function stripAccordionsHaspopup() {
    document
      .querySelectorAll('button[data-accordion-trigger][aria-haspopup="true"]')
      .forEach((btn) => btn.removeAttribute('aria-haspopup'));
  }

  function runWithRetries() {
    let tries = 0;
    const maxTries = 20;
    const interval = 100;

    stripAccordionsHaspopup();

    const timer = setInterval(() => {
      stripAccordionsHaspopup();
      tries += 1;

      if (
        tries >= maxTries ||
        document.querySelectorAll('button[data-accordion-trigger][aria-haspopup="true"]').length === 0
      ) {
        clearInterval(timer);
      }
    }, interval);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runWithRetries);
  } else {
    runWithRetries();
  }

  document.addEventListener('theme:section:load', runWithRetries);
})();


// Join Our Newsletter (Klaviyo) / 3rd party post-render fix
(function () {
  function findNewsletterTrigger() {
    return document.querySelector('[class*="kl-teaser-"] span[role="button"][tabindex="0"]');
  }

  function findNewsletterDialog() {
    var dialogs = document.querySelectorAll('[role="dialog"][aria-modal="true"]');
    for (var i = 0; i < dialogs.length; i++) {
      var id = dialogs[i].id || '';
      if (id.indexOf('cookie') === -1) return dialogs[i];
    }
    return null;
  }

  function applyTriggerFix(trigger) {
    if (!trigger) return;

    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-label', 'Join our newsletter');

    var innerTextWrapper = trigger.querySelector('[id^="rich-text-"]');
    if (innerTextWrapper) innerTextWrapper.setAttribute('aria-hidden', 'true');
  }

  function applyDialogFix(dialog) {
    if (!dialog) return;

    var dialogHeading = dialog.querySelector('h1, h2, h3, [role="heading"]');
    if (dialogHeading) {
      if (!dialogHeading.id) dialogHeading.id = 'kl-newsletter-title';
      dialog.setAttribute('aria-labelledby', dialogHeading.id);
    } else {
      dialog.setAttribute('aria-label', 'Newsletter sign up');
    }
  }

  function applyNewsletterAccessibilityFix() {
    applyTriggerFix(findNewsletterTrigger());
    applyDialogFix(findNewsletterDialog());
  }

  applyNewsletterAccessibilityFix();

  var pageChangeObserver = new MutationObserver(function () {
    applyNewsletterAccessibilityFix();
  });

  pageChangeObserver.observe(document.documentElement, { childList: true, subtree: true });
})();

// // After removing a cart item, move focus to the cart drawer heading
// (function () {
//   var shouldRefocus = false;

//   function getCartDrawer() {
//     return document.querySelector('#drawer-cart');
//   }

//   function getCartTitle() {
//     var drawer = getCartDrawer();
//     if (!drawer) return null;
//     return drawer.querySelector('.cart__drawer__title-heading');
//   }

//   function focusCartTitle() {
//     var title = getCartTitle();
//     if (!title) return;
//     title.focus();
//   }

//   document.addEventListener(
//     'click',
//     function (e) {
//       var removeLink = e.target.closest('a.cart__items__remove');
//       if (!removeLink) return;
//       shouldRefocus = true;
//     },
//     true
//   );

//   function observeCartDrawer() {
//     var drawer = getCartDrawer();
//     if (!drawer) return;

//     var observer = new MutationObserver(function () {
//       if (!shouldRefocus) return;

//       shouldRefocus = false;

//       setTimeout(function () {
//         focusCartTitle();
//       }, 0);
//     });

//     observer.observe(drawer, { childList: true, subtree: true });
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', observeCartDrawer);
//   } else {
//     observeCartDrawer();
//   }
// })();

/**** CART/CART DRAWER ***/
// cart icon opens cart drawer
// close cart with "X", ESC or clicking underlay
// focus returns to cart icon
(function () {
  var CART_DRAWER_ID = 'drawer-cart';
  var lastCartTrigger = null;
  var lastIsOpen = null;
  var shouldRefocusTitleAfterRemove = false;

  function getCartDrawer() {
    return document.getElementById(CART_DRAWER_ID);
  }

  function isCartOpen() {
    var drawer = getCartDrawer();
    return !!(drawer && drawer.classList.contains('drawer--visible'));
  }

  function getCartTriggers() {
    return document.querySelectorAll('[data-drawer-toggle="drawer-cart"]');
  }

  function isInsideCartDrawer(el) {
    var drawer = getCartDrawer();
    return !!(drawer && el && drawer.contains(el));
  }

  function getCartTitle() {
    var drawer = getCartDrawer();
    if (!drawer) return null;
    return drawer.querySelector('.cart__drawer__title-heading');
  }

  function focusCartTitle() {
    var title = getCartTitle();
    if (title) title.focus();
  }

  function focusLastTrigger() {
    if (lastCartTrigger && document.contains(lastCartTrigger)) {
      lastCartTrigger.focus();
    }
  }

  function focusIntoCartDrawer() {
    var drawer = getCartDrawer();
    if (!drawer) return;

    var closeBtn = drawer.querySelector('button.drawer__button.drawer__close');
    if (closeBtn) {
      closeBtn.focus();
      return;
    }

    focusCartTitle();
  }

  function setExpandedOnTriggers(expanded) {
    var triggers = getCartTriggers();
    for (var i = 0; i < triggers.length; i++) {
      triggers[i].setAttribute('aria-expanded', expanded ? 'true' : 'false');
      triggers[i].setAttribute('aria-controls', CART_DRAWER_ID);
      triggers[i].setAttribute('aria-haspopup', 'dialog');
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      var removeLink = e.target.closest('a.cart__items__remove');
      if (removeLink) {
        shouldRefocusTitleAfterRemove = true;
        return;
      }

      var trigger = e.target.closest('[data-drawer-toggle="drawer-cart"]');
      if (!trigger) return;

      if (!isInsideCartDrawer(trigger)) {
        lastCartTrigger = trigger;
      }

      if (!isInsideCartDrawer(trigger)) {
        e.preventDefault();
      }
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (e) {
      var trigger = e.target.closest('[data-drawer-toggle="drawer-cart"]');
      if (!trigger) return;

      if (!isInsideCartDrawer(trigger)) {
        lastCartTrigger = trigger;
      }

      if (e.key === ' ') {
        e.preventDefault();
        trigger.click();
      }
    },
    true
  );

  function handleCartStateChange() {
    var open = isCartOpen();

    if (lastIsOpen === null) {
      lastIsOpen = open;
      setExpandedOnTriggers(open);
      return;
    }

    if (open === lastIsOpen) return;

    lastIsOpen = open;
    setExpandedOnTriggers(open);

    if (open) {
      setTimeout(focusIntoCartDrawer, 0);
      return;
    }

    setTimeout(function () {
      focusLastTrigger();
    }, 0);
  }

  function handleCartDomChange() {
    if (!isCartOpen()) return;

    if (shouldRefocusTitleAfterRemove) {
      shouldRefocusTitleAfterRemove = false;
      setTimeout(focusCartTitle, 0);
    }
  }

  function observeCartDrawer() {
    var drawer = getCartDrawer();
    if (!drawer) return;

    var stateObserver = new MutationObserver(handleCartStateChange);
    stateObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });

    var contentObserver = new MutationObserver(handleCartDomChange);
    contentObserver.observe(drawer, { childList: true, subtree: true });

    handleCartStateChange();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeCartDrawer);
  } else {
    observeCartDrawer();
  }
})();


/**** CART DRAWER: announce updated cart subtotal when cart changes  ***/
(function () {
  var CART_DRAWER_ID = 'drawer-cart';
  var LINE_ITEMS_HOST_SEL = '[data-line-items]';
  var LIVE_REGION_SEL = '#cart-a11y-live, [data-cart-a11y-live]';

  var pendingQtyAction = null;
  var latestTotalText = '';
  var shouldAnnounceAfterRender = false;

  function getCartDrawer() {
    return document.getElementById(CART_DRAWER_ID);
  }

  function getLineItemsHost() {
    var drawer = getCartDrawer();
    if (!drawer) return null;
    return drawer.querySelector(LINE_ITEMS_HOST_SEL);
  }

  function getLiveRegion() {
    var drawer = getCartDrawer();
    if (!drawer) return null;
    return drawer.querySelector(LIVE_REGION_SEL);
  }

  function ensureLiveRegionReady(live) {
    if (!live) return null;

    if (!live.id) live.id = 'cart-a11y-live';
    live.setAttribute('role', 'status');
    live.setAttribute('aria-live', 'polite');
    live.setAttribute('aria-atomic', 'true');

    return live;
  }

  function writeLiveMessage(message) {
    var live = ensureLiveRegionReady(getLiveRegion());
    if (!live) return;

    live.textContent = '';
    requestAnimationFrame(function () {
      live.textContent = message;
    });
  }

  function getKeyFromQuantityButton(btn) {
    var grid = btn.closest('.cart__items__grid');
    if (!grid) return null;

    var removeLink = grid.querySelector('a.cart__items__remove[data-remove-key]');
    if (!removeLink) return null;

    return removeLink.getAttribute('data-remove-key');
  }

  function restoreFocusToUpdatedButton() {
    if (!pendingQtyAction) return null;

    var drawer = getCartDrawer();
    if (!drawer) return null;

    var removeLink = drawer.querySelector(
      'a.cart__items__remove[data-remove-key="' + pendingQtyAction.key + '"]'
    );
    if (!removeLink) return null;

    var grid = removeLink.closest('.cart__items__grid');
    if (!grid) return null;

    var selector =
      pendingQtyAction.which === 'inc'
        ? 'button[data-increase-quantity]'
        : 'button[data-decrease-quantity]';

    var target = grid.querySelector(selector) || grid.querySelector('input[data-quantity-input]');
    if (!target) return null;

    pendingQtyAction = null;
    target.focus();

    return target;
  }

  function describeFocusWithLiveRegion(focusedEl) {
    var live = ensureLiveRegionReady(getLiveRegion());
    if (!live || !focusedEl) return;

    var liveId = live.id;

    var existing = (focusedEl.getAttribute('aria-describedby') || '').trim();
    var tokens = existing ? existing.split(/\s+/) : [];
    if (tokens.indexOf(liveId) === -1) tokens.push(liveId);

    focusedEl.setAttribute('aria-describedby', tokens.join(' ').trim());

    setTimeout(function () {
      if (!document.contains(focusedEl)) return;

      var current = (focusedEl.getAttribute('aria-describedby') || '').trim();
      if (!current) return;

      var next = current
        .split(/\s+/)
        .filter(function (t) {
          return t && t !== liveId;
        })
        .join(' ')
        .trim();

      if (next) focusedEl.setAttribute('aria-describedby', next);
      else focusedEl.removeAttribute('aria-describedby');
    }, 1200);
  }

  document.addEventListener(
    'click',
    function (e) {
      var drawer = getCartDrawer();
      if (!drawer) return;

      var btn = e.target.closest('button[data-increase-quantity], button[data-decrease-quantity]');
      if (!btn) return;
      if (!drawer.contains(btn)) return;

      var key = getKeyFromQuantityButton(btn);
      if (!key) return;

      pendingQtyAction = {
        key: key,
        which: btn.hasAttribute('data-increase-quantity') ? 'inc' : 'dec'
      };

      shouldAnnounceAfterRender = true;
    },
    true
  );

  document.addEventListener('theme:cart:change', function (e) {
    var cart = e && e.detail && e.detail.cart ? e.detail.cart : null;
    if (!cart) return;

    if (typeof cart.total_price === 'number') {
      latestTotalText = String(cart.total_price);
    } else if (cart.total_price) {
      latestTotalText = String(cart.total_price);
    }
  });

  function formatSubtotalForSpeech(text) {
    var clean = text.replace(/\s+/g, ' ').trim();

    var match = clean.match(/([^\d]*)(\d+)\.(\d{2})/);
    if (!match) return clean;

    var currency = match[1];
    var dollars = match[2];
    var cents = match[3];

    return currency + dollars + ' dollars and ' + cents + ' cents';
  }

  function announceIfNeeded(focusedEl) {
    if (!shouldAnnounceAfterRender) return;
    shouldAnnounceAfterRender = false;

    var message = '';

    var totalNode = document.querySelector('#' + CART_DRAWER_ID + ' [data-cart-final]');
    if (totalNode) {
      var rawSubtotal = totalNode.textContent.replace(/\s+/g, ' ').trim();
      var numeric = rawSubtotal.match(/(\d+)\.(\d{2})/);

      if (numeric) {
        var dollars = numeric[1];
        var cents = numeric[2];
        message = 'Cart updated. Subtotal is ' + dollars + ' dollars and ' + cents + ' cents.';
      } else {
        message = 'Cart updated. Subtotal is ' + rawSubtotal + '.';
      }
    }

    if (!message && latestTotalText) {
      message = 'Cart updated.';
    }

    if (!message) return;

    writeLiveMessage(message);
    describeFocusWithLiveRegion(focusedEl);
  }

  function bindObserver() {
    var drawer = getCartDrawer();
    if (!drawer) return;

    if (drawer.__a11yQtyAnnounceBound) return;
    drawer.__a11yQtyAnnounceBound = true;

    var host = getLineItemsHost();
    if (!host) return;

    var obs = new MutationObserver(function () {
      if (!pendingQtyAction && !shouldAnnounceAfterRender) return;

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          var focusedEl = restoreFocusToUpdatedButton();
          announceIfNeeded(focusedEl);
        });
      });
    });

    obs.observe(host, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindObserver);
  } else {
    bindObserver();
  }

  document.addEventListener('shopify:section:load', bindObserver);
})();

/**** PRODUCT PAGE THUMBNAIL  */
document.addEventListener('keydown', (e) => {
  const thumb = e.target.closest('[data-product-thumbs] [data-slideshow-thumbnail]');
  if (!thumb) return;

  const key = e.key;

  if (key === 'Enter' || key === ' ') {
    e.preventDefault();
    thumb.click();
    return;
  }

  if (key !== 'ArrowLeft' && key !== 'ArrowRight' && key !== 'ArrowUp' && key !== 'ArrowDown') return;

  e.preventDefault();

  const thumbsWrapper = thumb.closest('[data-product-thumbs]');
  if (!thumbsWrapper) return;

  const thumbs = Array.from(thumbsWrapper.querySelectorAll('[data-slideshow-thumbnail]'));
  const currentIndex = thumbs.indexOf(thumb);
  if (currentIndex === -1) return;

  const dir = (key === 'ArrowLeft' || key === 'ArrowUp') ? -1 : 1;
  const nextIndex = currentIndex + dir;

  if (thumbs[nextIndex]) thumbs[nextIndex].focus();
});

/**** REMOVE FLICKITY WRAPPER FROM TAB ORDER ****/
document.querySelectorAll('[data-product-thumbs].media__thumb__wrapper[tabindex="0"]').forEach(el => {
  el.removeAttribute('tabindex');
});

/**** 'READ MORE' TRUNCATION STATE ****/
/**** READ MORE BUTTON STATE ****/
document.addEventListener('click', function (event) {
  const button = event.target.closest('button[data-truncated-button]');
  if (!button) return;

  const tabPanel = button.closest('.tab-content');
  if (!tabPanel) return;

  requestAnimationFrame(function () {
    const truncatedEntry = tabPanel.querySelector('.tab-content__entry--truncate');
    if (!truncatedEntry) return;

    const truncatedEntryIsHidden = window.getComputedStyle(truncatedEntry).display === 'none';

    button.setAttribute('aria-expanded', truncatedEntryIsHidden ? 'true' : 'false');
  });
});

/**** PRODUCT TABS A11Y – Tablist semantics, arrow keys, and focus into tab panel ****/
(function () {
  function applyProductTabsA11y(productTabsComponent) {
    if (!productTabsComponent || productTabsComponent.dataset.a11yTabsInitialized === 'true') return;
    productTabsComponent.dataset.a11yTabsInitialized = 'true';

    const tabList = productTabsComponent.querySelector('.product-tabs-title');
    if (!tabList) return;

    const tabButtons = Array.from(tabList.querySelectorAll('.tab-link'));
    const tabPanels = Array.from(productTabsComponent.querySelectorAll('.tab-content'));
    if (!tabButtons.length || !tabPanels.length) return;

    tabList.setAttribute('role', 'tablist');
    tabList.setAttribute('aria-label', tabList.getAttribute('aria-label') || 'Product details');

    const baseId = productTabsComponent.id || productTabsComponent.dataset.tabsId || 'product-tabs';

    function updateTabsAndPanels(shouldMoveFocusToPanel) {
      const activeTab = tabList.querySelector('.tab-link.current') || tabButtons[0];
      const activeIndex = Math.max(0, tabButtons.indexOf(activeTab));

      tabButtons.forEach((tabButton, index) => {
        const tabId = tabButton.id || `${baseId}-tab-${index}`;
        tabButton.id = tabId;

        tabButton.setAttribute('role', 'tab');
        tabButton.setAttribute('aria-selected', index === activeIndex ? 'true' : 'false');
        tabButton.setAttribute('tabindex', index === activeIndex ? '0' : '-1');

        const panel = tabPanels[index];
        if (!panel) return;

        const panelId = panel.id || `${baseId}-panel-${index}`;
        panel.id = panelId;

        tabButton.setAttribute('aria-controls', panelId);

        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tabId);

        if (index === activeIndex) {
          panel.removeAttribute('hidden');
          panel.setAttribute('tabindex', '-1');
        } else {
          panel.setAttribute('hidden', '');
          panel.removeAttribute('tabindex');
        }
      });

      if (!shouldMoveFocusToPanel) return;

      const activePanel = tabPanels[activeIndex];
      if (activePanel) {
        activePanel.focus();
      }
    }

    function activateTabByIndex(nextIndex) {
      const nextTab = tabButtons[nextIndex];
      if (!nextTab) return;

      nextTab.click();

      requestAnimationFrame(function () {
        updateTabsAndPanels(true);
      });
    }

    updateTabsAndPanels(false);

    tabList.addEventListener('click', function (event) {
      const clickedTab = event.target.closest('.tab-link');
      if (!clickedTab) return;

      requestAnimationFrame(function () {
        updateTabsAndPanels(true);
      });
    });

    tabList.addEventListener('keydown', function (event) {
      const focusedTab = event.target.closest('.tab-link');
      if (!focusedTab) return;

      const currentIndex = tabButtons.indexOf(focusedTab);

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        const nextIndex = (currentIndex - 1 + tabButtons.length) % tabButtons.length;
        activateTabByIndex(nextIndex);
        return;
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        const nextIndex = (currentIndex + 1) % tabButtons.length;
        activateTabByIndex(nextIndex);
        return;
      }

      if (event.key === 'Home') {
        event.preventDefault();
        activateTabByIndex(0);
        return;
      }

      if (event.key === 'End') {
        event.preventDefault();
        activateTabByIndex(tabButtons.length - 1);
        return;
      }

      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        focusedTab.click();

        requestAnimationFrame(function () {
          updateTabsAndPanels(true);
        });
      }
    });
  }

  function initProductTabsIfPresent() {
    const productTabsComponents = document.querySelectorAll('[data-tabs-holder]');
    if (!productTabsComponents.length) return false;

    productTabsComponents.forEach(function (productTabsComponent, index) {
      if (!productTabsComponent.dataset.tabsId) {
        productTabsComponent.dataset.tabsId = String(index);
      }
      applyProductTabsA11y(productTabsComponent);
    });

    return true;
  }

  const foundImmediately = initProductTabsIfPresent();
  if (foundImmediately) return;

  const domObserver = new MutationObserver(function () {
    const foundNow = initProductTabsIfPresent();
    if (foundNow) domObserver.disconnect();
  });

  domObserver.observe(document.documentElement, { childList: true, subtree: true });

})();

/**** CUSTOMER SERVICE FORM – interrupt submission if form is invalid ****/
(function () {
  var form = document.getElementById('contact-us-page');

  if (!form) return;

  var errorBox = form.querySelector('.errors');
  var emailField = form.querySelector('input[name="contact[email]"]');
  var messageField = form.querySelector('textarea[name="contact[body]"]');

  function clearErrors() {
    if (errorBox) {
      errorBox.remove();
      errorBox = null;
    }

    [emailField, messageField].forEach(function (field) {
      if (!field) return;

      field.removeAttribute('aria-invalid');

      var describedBy = field.getAttribute('aria-describedby');
      if (!describedBy) return;

      var ids = describedBy.split(' ').filter(function (id) {
        return id !== 'contact-email-error' && id !== 'contact-message-error';
      });

      if (ids.length) {
        field.setAttribute('aria-describedby', ids.join(' '));
      } else {
        field.removeAttribute('aria-describedby');
      }
    });

    var oldMessages = form.querySelectorAll('.field-error');
    oldMessages.forEach(function (msg) {
      msg.remove();
    });
  }

  function addFieldError(field, message, id) {
    if (!field) return;

    field.setAttribute('aria-invalid', 'true');

    var existingDescribedBy = field.getAttribute('aria-describedby');
    var describedByValues = existingDescribedBy ? existingDescribedBy.split(' ') : [];

    if (describedByValues.indexOf(id) === -1) {
      describedByValues.push(id);
    }

    field.setAttribute('aria-describedby', describedByValues.join(' ').trim());

    var error = document.createElement('p');
    error.className = 'field-error';
    error.id = id;
    error.textContent = message;

    field.insertAdjacentElement('afterend', error);
  }

  function addTopError(messages) {
    var wrapper = document.createElement('div');
    wrapper.className = 'errors';
    wrapper.setAttribute('aria-live', 'polite');
    wrapper.setAttribute('role', 'alert');

    var intro = document.createElement('p');
    intro.className = 'form-error-summary';

    if (messages.length === 1) {
      intro.textContent = '1 error found in the form.';
    } else {
      intro.textContent = messages.length + ' errors found in the form.';
    }

    var ul = document.createElement('ul');

    messages.forEach(function (message) {
      var li = document.createElement('li');
      li.textContent = message;
      ul.appendChild(li);
    });

    wrapper.appendChild(intro);
    wrapper.appendChild(ul);
    form.insertBefore(wrapper, form.firstElementChild);
    errorBox = wrapper;
  }

  form.addEventListener('submit', function (event) {
    clearErrors();

    var messages = [];
    var emailValue = emailField ? emailField.value.trim() : '';
    var messageValue = messageField ? messageField.value.trim() : '';
    var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (emailField && emailValue === '') {
      messages.push('Email address is required.');
      addFieldError(emailField, 'Email address is required.', 'contact-email-error');
    } else if (emailField && !emailPattern.test(emailValue)) {
      messages.push('Please enter a valid email address.');
      addFieldError(emailField, 'Please enter a valid email address.', 'contact-email-error');
    }

    if (messageField && messageField.hasAttribute('required') && messageValue === '') {
      messages.push('Message is required.');
      addFieldError(messageField, 'Message is required.', 'contact-message-error');
    }

    if (messages.length > 0) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      addTopError(messages);
      if (emailField && emailField.getAttribute('aria-invalid') === 'true') {
        emailField.focus();
      } else if (messageField && messageField.getAttribute('aria-invalid') === 'true') {
        messageField.focus();
      }
      return false;
    }
  });
})();

/**** ACCORDION ARIA EXPANDED CONTROLS ****/
(function () {
  var accordionButtons = document.querySelectorAll('.accordion__title[data-accordion-trigger]');
  
  accordionButtons.forEach(function (button) {
    function syncAccordionState() {
      var isOpen = button.classList.contains('accordion-is-open');
      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    syncAccordionState();

    button.addEventListener('click', function () {
      window.setTimeout(syncAccordionState, 0);
    });

  });

})();


/**** PREDICTIVE SEARCH ****/
(function () {
  var input = document.querySelector('[data-predictive-search-input]');
  if (!input) return;

  var wrapper = document.querySelector('[data-predictive-search-aria]');
  if (!wrapper) return;

  var announceTimer;

  function announce() {
    var items = document.querySelectorAll('[data-product-wrap] li');
    var query = input.value.trim();

    if (!query) {
      wrapper.textContent = '';
      return;
    }

    var count = items.length;
    var message = count > 0
      ? count + ' results for ' + query
      : 'No results for ' + query;

    // clear first
    wrapper.textContent = '';

    // force reflow
    wrapper.offsetHeight;

    // then update
    wrapper.textContent = message;
  }

  input.addEventListener('input', function () {
    setTimeout(announce, 300);
  });
})();

 
/**** FILTER AND SORT ANNOUNCEMENTS ****/
(function() {
  const liveRegion = document.getElementById('a11y-live-status');
  if (!liveRegion) return;

  let lastMessage = '';

  setInterval(() => {
    const statusEl = document.getElementById('search-results-status');
    if (statusEl) {
      const currentMessage = statusEl.textContent.trim();
      
      if (currentMessage && currentMessage !== lastMessage) {
        
        liveRegion.textContent = '';
        
        setTimeout(() => {
          liveRegion.textContent = currentMessage;
          statusEl.setAttribute('tabindex', '-1');
          statusEl.focus();
        }, 400);
        
        lastMessage = currentMessage;
      }
    }
  }, 700);

})();


/**** COLLECTION TABS PANEL KEYBOARD SUPPORT ****/
(function () {
  function getTabButtons(holder) {
    return Array.from(holder.querySelectorAll('.tabs [role="tab"]'));
  }

  function getActiveTab(holder) {
    var currentLi = holder.querySelector('.tab-link.current [role="tab"]');
    if (currentLi) return currentLi;

    var selectedTab = holder.querySelector('.tabs [role="tab"][aria-selected="true"]');
    if (selectedTab) return selectedTab;

    return holder.querySelector('.tabs [role="tab"]');
  }

  // function syncTabs(holder) {
  //   var tabs = getTabButtons(holder);
  //   if (!tabs.length) return;

  //   var activeTab = getActiveTab(holder) || tabs[0];

  //   tabs.forEach(function (tab) {
  //     var isActive = tab === activeTab;
  //     tab.setAttribute('tabindex', isActive ? '0' : '-1');
  //     tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
  //   });
  // }

  function syncTabs(holder) {
    var tabs = getTabButtons(holder);
    if (!tabs.length) return;

    var activeTab = getActiveTab(holder) || tabs[0];
    var activePanelId = activeTab.getAttribute('aria-controls');

    tabs.forEach(function (tab) {
      var isActive = tab === activeTab;
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    var panels = holder.querySelectorAll('[role="tabpanel"]');

    panels.forEach(function (panel) {
      var isActivePanel = panel.id === activePanelId;
      var slider = panel.querySelector('.flickity-grid');

      if (isActivePanel) {
        panel.classList.add('current');
        panel.setAttribute('aria-hidden', 'false');
        panel.removeAttribute('inert');
        panel.setAttribute('tabindex', '0');

        if (slider) {
          slider.setAttribute('tabindex', '0');
        }
      } else {
        panel.classList.remove('current');
        panel.setAttribute('aria-hidden', 'true');
        panel.setAttribute('inert', '');
        panel.setAttribute('tabindex', '-1');

        if (slider) {
          slider.setAttribute('tabindex', '-1');
        }
      }
    });
  }

  function focusAndActivateTab(tab) {
    if (!tab) return;
    tab.focus();
    tab.click();

    requestAnimationFrame(function () {
      var holder = tab.closest('[data-tabs-holder]');
      if (holder) syncTabs(holder);
    });
  }

  function onTabKeydown(event) {
    var tab = event.target.closest('[role="tab"]');
    if (!tab) return;

    var holder = tab.closest('[data-tabs-holder]');
    if (!holder) return;

    var tabs = getTabButtons(holder);
    if (!tabs.length) return;

    var currentIndex = tabs.indexOf(tab);
    if (currentIndex === -1) return;

    var targetIndex = null;

    if (event.key === 'ArrowRight') {
      targetIndex = currentIndex === tabs.length - 1 ? 0 : currentIndex + 1;
    } else if (event.key === 'ArrowLeft') {
      targetIndex = currentIndex === 0 ? tabs.length - 1 : currentIndex - 1;
    } else if (event.key === 'Home') {
      targetIndex = 0;
    } else if (event.key === 'End') {
      targetIndex = tabs.length - 1;
    } else {
      return;
    }

    event.preventDefault();
    focusAndActivateTab(tabs[targetIndex]);
  }

  function initCollectionTabsA11y() {
    var holders = document.querySelectorAll('[data-tabs-holder]');
    if (!holders.length) return;

    holders.forEach(function (holder) {
      syncTabs(holder);

      var tablist = holder.querySelector('.tabs[role="tablist"]');
      if (!tablist || tablist.dataset.a11yTabsBound === 'true') return;

      tablist.addEventListener('keydown', onTabKeydown);

      tablist.addEventListener('click', function (event) {
        var clickedTab = event.target.closest('[role="tab"]');
        if (!clickedTab) return;

        requestAnimationFrame(function () {
          syncTabs(holder);
        });
      });

      tablist.dataset.a11yTabsBound = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionTabsA11y);
  } else {
    initCollectionTabsA11y();
  }

  window.addEventListener('load', initCollectionTabsA11y);
})();